// eslint-disable-next-line no-restricted-imports
import { LinearProgress as LinearProgressMUI, styled } from '@mui/material';

export type LinearProgressProps = {
  max?: number;
  className?: string;
  variant?: 'determinate';
  value: number;
};

const StyledProgress = styled(LinearProgressMUI)({
  borderRadius: 4,
  background: 'var(--input-input-background-color)',
});

export const LinearProgress = ({
  className,
  max,
  value,
  variant,
}: LinearProgressProps) => {
  const progress = max ? (value / max) * 100 : 0;

  return (
    <StyledProgress
      className={className}
      variant={
        variant || (max && progress < 100 ? 'determinate' : 'indeterminate')
      }
      value={progress}
    />
  );
};
